import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { Route, RouteComponentProps } from 'react-router-dom';
import { RoutePrefix } from '../../../Routes';
import { FormState } from '../../../components/Form';
import { RouteName } from '../@data';
import { onCurrentRouteChanged } from '../@data/actions';
import '../@data/orchestrators';
import './@data/mutators';
import './@data/orchestrators';
import { CreatePublisher } from './Create/CreatePublisher';
import { ManagePage } from './Manage/ManagePage';

export const PublisherPage = injectIntl(function PublisherPageComponent({
  match,
  intl,
}: RouteComponentProps & InjectedIntlProps): JSX.Element {
  React.useEffect(() => {
    onCurrentRouteChanged(RouteName.publisher, intl.formatMessage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <React.Fragment>
      <Route exact path={`${match.url}`} component={ManagePage} />
      <Route path={`${match.url}/create`} render={(props) => <CreatePublisher {...props} mode={FormState.Create} />} />
      <Route
        path={`/${RoutePrefix.partnerManagement}/:publisherId/${RouteName[RouteName.publisher]}/edit/:id`}
        render={(props) => <CreatePublisher {...props} mode={FormState.Edit} />}
      />
    </React.Fragment>
  );
});
